module.exports = __webpack_public_path__ + "img/0Q3B2213_L_Wood_MockedUp.2913b0b0.jpg";